import type { Configuration } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import type { IRequest } from '../../request/Types';
import { VehicleSuggestionAPIToVehicleSuggestion } from './APITransformer';
import type { VehicleInfoSuggestion, VehicleSuggestionAPI } from './Types';

export class VehicleInfoSuggestions {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  public getSuggestion = (plate: string): Promise<VehicleInfoSuggestion> => {
    const requestData: IRequest = {
      endpoint: `/vehicle/suggestion?plate=${plate}`,
      method: HttpMethod.GET,
    };

    return this.requester.request(requestData).then((response) => {
      const vehicleSuggestionAPI: VehicleSuggestionAPI = response.data;
      return VehicleSuggestionAPIToVehicleSuggestion(vehicleSuggestionAPI);
    });
  };

  public getSuggestionBatch = (plates: string[]): Promise<Record<string, VehicleInfoSuggestion>> => {
    const requestData: IRequest = {
      endpoint: '/vehicle/suggestion/batch',
      method: HttpMethod.POST,
      body: JSON.stringify({ plates }),
    };

    return this.requester.request(requestData).then((response) => {
      const raw: Record<string, VehicleSuggestionAPI> = response.data;
      return Object.fromEntries(Object.entries(raw).map(([plate, api]) => [plate, VehicleSuggestionAPIToVehicleSuggestion(api)]));
    });
  };
}

export default VehicleInfoSuggestions;
